import React, {Component} from 'react';
import connect from "react-redux/es/connect/connect";
import {setCurrentNavPage} from "actions";
import PageHeader from "../../components/common/PageHeader/PageHeader";
import DocumentApplicationFilters from "../../components/Filters/Statistics/DocumentApplicationFilters";
import FacturationStatisticsBloc from "../../components/Admin/statisctics/FacturationStatisticsBloc";
import PaymentStatisticsBloc from "../../components/Admin/statisctics/PaymentStatisticsBloc";
import NotPaidInvoices from "../../components/Admin/statisctics/NotPaidInvoices";
import _ from "i18n";
import SidePageHeader from "../../components/common/SidePageHeader";
import SidePageStatisticHeader
  from "../../components/common/SidePageStatisticHeader";
import {notification} from "antd";
import PeriodFilter from '../../components/Filters/EventStats/PeriodFilter';

const openNotificationWithIcon = (type, description, message) => {
  notification[type]({
    message: message,
    description:
    description,
    style: {
      marginTop: 120,
    },
  });
};

class StatisticsPage extends Component {


  componentDidMount() {
    let stringUrl = window.location.href;
    let url = new URL(stringUrl);
    let isSucceeded = url.searchParams.get("isSucceeded");

    if(isSucceeded == 1){
      openNotificationWithIcon('success', _('REFUND_SUCCEEDED'), _('successfulAction'));
      url.searchParams.delete('isSucceeded');
      window.history.replaceState(null, null, url + '')
    } else if(isSucceeded == 0){
      openNotificationWithIcon('error', _('errorOccured'), _('error'))
      url.searchParams.delete('isSucceeded');
      window.history.replaceState(null, null, url + '')
    }

    this.props.setCurrentNavPage("STATISTICS");
  }

  closeCodaAlert = () => {
    this.setState({showCodaAlert: false});
  };

  changeStats = () => {
    this.setState({showStats: !this.state.showStats})
  }

  render() {

    const  organization = this.props.auth.currentClient ? (this.props.auth.currentClient.abbreviation ? this.props.auth.currentClient.abbreviation : this.props.auth.currentClient.name) : "";
    return (
      <div>
        <PageHeader
          header={_('stats')}
          subHeader={_('EN QUELQUES CHIFFRES')}
          icon="STATISTICS_HEADER"
          children={<PeriodFilter className={'ml-6 mt-1'} />}
        />

        <SidePageStatisticHeader subHeader={_("stats")}  organization = {organization} year = {this.props.statisticsFilter.year} appRefs = {this.props.statisticsFilter.appRefs} appRefsStore = {this.props.appRef}/>
        <div className="ttp-tab-container">
          <div className="ttp-tab-selector">
            <DocumentApplicationFilters/>
          </div>
          <FacturationStatisticsBloc/>

          <PaymentStatisticsBloc/>

          <NotPaidInvoices/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  statisticsFilter: state.filters.statisticsFilter,
  appRef: state.appRefFilter.items,
});

const mapDispatchToProps = {
  setCurrentNavPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(StatisticsPage);



// WEBPACK FOOTER //
// ./app/pages/Admin/StatisticsPage.js